import React from 'react';
import { initAudio } from '../utils/audioEngine';

export default function StartOverlay({ onStart }) {
  const handleStart = () => {
    initAudio();
    onStart();
  };

  return (
    <div id="start-overlay" style={{ display: 'flex' }}>
      
      {/* Decorative Musical Background Elements */}
      <div className="bg-glow"></div>
      <div className="bg-string s1"></div>
      <div className="bg-string s2"></div>
      <div className="bg-string s3"></div>
      
      <div className="start-content">
        <h1 className="app-title float-anim">True Guitar</h1>
        <p className="subtitle fade-in">Experience realistic tones right in your pocket</p>
        
        <button id="start-btn" onClick={handleStart} className="pulse-btn">PLAY</button>
        
        <div className="app-links fade-in-delayed">
          <button className="app-link-btn" disabled>Android App (Coming soon)</button>
          <button className="app-link-btn" disabled>iOS App (Coming soon)</button>
        </div>
      </div>
    </div>
  );
}
